import React, { useMemo } from 'react'
import { Container, Icon } from 'gu-ui-kit'
import styles from 'modules/Finance/PaymentProfiles/Invoices/components/StatusIcon/status-icon.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const StatusIcon = ({ status, breakpoints }) => {
  const iconConf = useMemo(() => {
    switch (status) {
      case 'new':
        return { name: 'transaction new', color: 'secondary-grey' }
      case 'pending':
        return { name: 'transaction pending', color: 'secondary-69' }
      case 'waiting':
        return { name: 'money', color: 'secondary-46' }
      case 'paid':
        return { name: 'transaction paid', color: 'secondary-11' }
      case 'canceled':
        return { name: 'transaction canceled', color: 'secondary-46' }
    }
  }, [status])

  return (
    <Container
      display={'flex'}
      className={clsx(styles['container'], {
        [styles['container_' + status]]: status,
        [styles['container_small']]: breakpoints.sm,
      })}
    >
      <Icon
        size={'as-is'}
        name={iconConf.name}
        className={clsx(styles['icon'], {
          [styles['icon_' + status]]: status,
        })}
      />
    </Container>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['new', 'pending', 'approved', 'declined']),
  breakpoints: PropTypes.object,
}

export default StatusIcon
